// extracted by mini-css-extract-plugin
export default {"st0":"DealerPortalLogo-BY0fN__st0","st1":"DealerPortalLogo-E1Ih8__st1"};